import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { useApi, useLoad } from "@/lib/api";
import { Panel, Table, day } from "@/pages/console/Kit";

function Create({ onDone }) {
  const api = useApi();
  const [csv, setCsv] = useState("pharmacy name,contact email,company number\n");
  const [campaign, setCampaign] = useState("");
  const [days, setDays] = useState(60);
  const go = async () => {
    try { const r = await api("post", "/admin/vouchers/bulk", { csv, campaign, days: Number(days) }); toast.success(`${r.created} codes created${r.skipped.length ? `, ${r.skipped.length} skipped` : ""}`); onDone(); } catch (e) { toast.error(e.message); }
  };
  return (
    <Panel title="Create voucher codes" testid="vouchers-create">
      <p className="mb-2 text-sm text-slate-600">Paste a CSV with pharmacy name, contact email and (optional) company number. Each row gets a one-month-free code.</p>
      <Textarea rows={5} value={csv} onChange={(e) => setCsv(e.target.value)} className="font-mono text-xs" data-testid="vouchers-csv-input" />
      <div className="mt-3 flex flex-wrap gap-2">
        <Input className="w-56" placeholder="Campaign name" value={campaign} onChange={(e) => setCampaign(e.target.value)} data-testid="vouchers-campaign-input" />
        <Input className="w-28" type="number" value={days} onChange={(e) => setDays(e.target.value)} data-testid="vouchers-days-input" />
        <span className="self-center text-sm text-slate-500">days valid</span>
        <Button onClick={go} data-testid="vouchers-create-button">Create codes</Button>
      </div>
    </Panel>
  );
}

export default function Vouchers() {
  const api = useApi();
  const v = useLoad("/admin/vouchers");
  const act = async (path, msg) => { try { const r = await api("post", path); toast.success(r.status ? `Email ${r.status}` : msg); v.reload(); } catch (e) { toast.error(e.message); } };
  return (
    <div className="space-y-6">
      <Create onDone={v.reload} />
      <Panel title="Campaign report"><Table rows={v.data?.report || []} cols={[["campaign", "Campaign"], ["issued", "Issued"], ["redeemed", "Redeemed"], ["converted", "Paid after free month"], ["cancelled", "Cancelled in month one"]]} /></Panel>
      <Panel title="All codes">
        <Table testid="vouchers-table" rows={v.data?.vouchers || []} cols={[
          ["code", "Code", (r) => <span className="font-mono">{r.code}</span>], ["pharmacy", "Pharmacy"], ["email", "Email"], ["campaign", "Campaign"],
          ["status", "Status"], ["expires", "Expires", (r) => day(r.expires)], ["emailed", "Emailed", (r) => (r.emailed ? "Yes" : "No")],
          ["x", "", (r) => r.status === "issued" && <div className="flex gap-1">
            <Button size="sm" variant="outline" onClick={() => act(`/admin/vouchers/${r.code}/email`)} data-testid={`voucher-email-${r.code}`}>Email</Button>
            <Button size="sm" variant="ghost" onClick={() => act(`/admin/vouchers/${r.code}/withdraw`, "Withdrawn")} data-testid={`voucher-withdraw-${r.code}`}>Withdraw</Button></div>]]} />
      </Panel>
    </div>
  );
}
